<template>
  <div class="container menu-info">
    <el-alert
      style="margin-bottom:20px;"
      :title="$t('management.menu.leval_tips')"
      type="info"
      simple
      show-icon
    >
    </el-alert>
    <el-form
      label-width="120px"
      :model="form"
      content-width="240px"
      :rules="rules"
      ref="form"
    >
      <el-form-item
        :label="$t('management.menu.name_label')"
        prop="name"
      >
        <el-input
          v-model="form.name"
          :maxlength="16"
          :placeholder="$t('management.menu.name_placeholder')"
        ></el-input>
      </el-form-item>
      <el-form-item
          :label="$t('management.menu.des_label')"
          prop="desc"
        >
        <el-input
          v-model="form.desc"
          :placeholder="$t('management.menu.des_placeholder')"
        />
      </el-form-item>
      <el-form-item
        :label="$t('management.menu.level_label')"
        prop="level"
      >
        <el-select
          v-model="form.level"
          @change="selectLevel"
        >
          <el-option
            :value="1"
            :label="$t('management.menu.menu_level_name1')"
          ></el-option>
          <el-option
            :value="2"
            :label="$t('management.menu.menu_level_name2')"
          ></el-option>
          <el-option
            :value="3"
            v-if="tabName !== 'toolNav'"
            :label="$t('management.menu.menu_level_name3')"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('management.menu.parent_menu_label')"
        prop="parentMenu"
        :rules="{
          type: 'array',
          required: form.level !== 1,
          message: $t('common.require_valid_error'),
          trigger: 'change'
        }"
      >
        <el-cascader
          v-if="tabName !== 'toolNav'"
          class="m-cascader"
          :options="parentMenu"
          :props="cascaderProps"
          :disabled="form.level === 1"
          :placeholder="$t('management.menu.parent_menu_placeholder')"
          v-model="form.parentMenu"
        >
        </el-cascader>
        <!-- :disabled="item.children&&item.children.length>=6" -->
        <el-select
          v-model="form.strParentMenu"
          v-else
          @change="selectParentMenu"
          :disabled="form.level === 1"
          :placeholder="$t('management.menu.parent_menu_placeholder')"
        >
          <el-option
            v-for="(item, index) in parentMenu"
            :key="index"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('management.menu.icon_label')"
        prop="fileId"
        v-if="(tabName==='toolNav'&&form.level===1)||(tabName==='app'&&form.level!==1)||(tabName!=='toolNav'&&tabName!=='app')"
        :rules="{
          required: form.level === 1 && tabName === 'toolNav',
          message: $t('management.menu.valid_icon'),
          trigger: 'change'
        }"
      >
        <el-input
          v-model="form.fileId"
          style="display:none"
        ></el-input>
        <menu-icon-upload
          type="menuIcon"
          v-model="form.icon"
        ></menu-icon-upload>
      </el-form-item>
      <el-form-item
        :label="$t('management.menu.url_label')"
        prop="url"
        :rules="[{
          type: 'string',
          required:  form.level>2&&tabName!=='toolNav'||form.level>1&&tabName==='toolNav',
          message: $t('common.require_valid_error'),
          trigger: 'blur'
        },noChinese,max255ChartRule]"
      >
        <el-input
          v-model="form.url"
          :placeholder="$t('management.menu.url_placeholder')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('management.menu.open_way_label')"
        prop="openType"
        v-if="tabName!=='config'&&tabName!=='personal'"
      >
        <el-select v-model="form.openType">
          <el-option
            :value="0"
            :label="$t('management.menu.open_type_name1')"
          ></el-option>
          <!-- <el-option
            :value="1"
            :label="$t('management.menu.open_type_name2')"
          ></el-option> -->
          <el-option
            :value="2"
            :label="$t('management.menu.open_type_name2')"
          ></el-option>
          <!-- <el-option :value="3"
            label="弹出新窗口"></el-option> -->
          <!-- <el-option
            :value="4"
            :label="$t('management.menu.open_type_name5')"
          ></el-option> -->
        </el-select>
        <!-- :disabled="form.level === 1" -->
        <!-- <el-select
          v-model="form.openType"
          v-else
        >
          <el-option
            :value="0"
            v-if="form.level === 1"
            :label="$t('management.menu.null')"
          ></el-option>
          <el-option
            :value="1"
            :label="$t('management.menu.open_type_name1')"
          ></el-option>
          <el-option
            :value="2"
            :label="$t('management.menu.open_type_name2')"
          ></el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item :label="$t('management.menu.show_home_label')">
        <el-switch
          v-model="form.isShow"
          :disabled="
            ((form.level === 1 && showToolLen >= 4) ||
              (form.level === 2 && showToolLen2 >= 6)) &&
              tabName === 'toolNav'
          "
        ></el-switch>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import MenuIconUpload from './menu-icon-upload'
import {
  requireRule,
  charRule,
  noChinese,
  max16ChartRule,
  requireNumberRule,
  max255ChartRule
} from 'utils/validator'
export default {
  name: 'menu-info',
  props: {
    menus: {
      type: Array,
      default: () => {
        return []
      }
    },
    tabName: {
      type: String,
      default: 'toolNav'
    },
    // 一级toolnav用
    showToolLen: {
      type: Number,
      default: 0
    },
    activeNode: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      max255ChartRule: max255ChartRule,
      noChinese: noChinese,
      form: {
        name: '',
        desc:'',
        parentId: -1,
        parentMenu: [],
        strParentMenu: '', // 导航工具栏用
        icon: {
          fileId: -1,
          path: ''
        },
        url: '',
        openType: 0,
        isShow: false,
        level: 1,
        fileId: ''
      },
      cascaderProps: {
        value: 'menuId',
        label: 'name'
      },
      rules: {
        name: [requireRule, charRule, max16ChartRule],
        level: [requireNumberRule],
        openType: [requireNumberRule],
        url: [noChinese]
      },
      // 二级toolNav用
      showToolLen2: 0,
      // 第一次加载的时候，同步菜单级别和父级菜单，在initForm之后，置为false
      syncFlag: true
    }
  },
  computed: {
    parentMenu () {
      let _menus = JSON.parse(JSON.stringify(this.menus))
      _menus.filter(item => !item.url || item.url === '')
      if (this.tabName !== 'toolNav') {
        let tempMenus = []
        _menus.forEach(item => {
          if (this.form.level === 2) {
            delete item.children
            tempMenus.push(item)
          } else if (this.form.level === 3) {
            if (item.children && item.children.length > 0) {
              tempMenus.push(item)
              let subMenus = item.children
              subMenus.forEach(subItem => {
                if (subItem.children && subItem.children.length > 0) {
                  delete subItem.children
                }
              })
            }
          }
        })
        return tempMenus
      } else {
        _menus.forEach(item => {
          if (item.children) {
            let tempArr = []
            item.children.forEach(subItem => {
              if (subItem.isShow) {
                tempArr.push(subItem)
              }
            })
            item.showToolLen = tempArr.length
          } else {
            item.showToolLen = 0
          }
        })
      }
      return _menus
    }
  },
  mounted () {
    this.initForm()
  },
  methods: {
    initForm () {
      if (this.activeNode.key) {
        this.form.level = this.activeNode.level + 1
        if (this.form.level === 2) {
          this.form.strParentMenu = this.activeNode.data.id
          this.form.parentMenu = [this.activeNode.data.menuId]
          this.$set(this.form, 'strParentMenu', this.activeNode.data.id)
        } else if (this.form.level === 3) {
          this.form.parentMenu = [this.activeNode.parent.data.menuId, this.activeNode.data.menuId]
        }
      }
    },
    selectLevel () {
      if (!this.syncFlag && this.form.parentMenu && this.form.parentMenu.length > 0) this.form.parentMenu = []
      this.syncFlag = false
    },
    selectParentMenu (menu) {
      this.form.parentMenu = [menu]
      this.parentMenu.forEach(item => {
        if (item.id === menu) {
          this.showToolLen2 = item.showToolLen
        }
      })
      if ((this.form.level === 1 && this.tabName === 'toolNav' && this.showToolLen >= 4) || (this.form.level === 2 && this.tabName === 'toolNav' && this.showToolLen2 >= 6)) {
        this.form.isShow = false
      }
    },
    _handleMenu (menu) {
      if (this.form.level === 2) {
        delete menu.children
      } else if (this.form.level === 3) {
        if (!menu.children || menu.children.length === 0) {
        }
      }
    },
    getResult () {
      let _res
      this.$refs.form.validate(valid => {
        _res = valid ? JSON.parse(JSON.stringify(this.form)) : false
      })
      _res.icon = _res.icon.fileId
      _res.parentId = _res.parentMenu.length
        ? _res.parentMenu[_res.parentMenu.length - 1]
        : -1
      delete _res.parentMenu
      return _res
    }
  },
  watch: {
    'form.icon' (val) {
      this.form.fileId = val.fileId === -1 ? '' : val.fileId
    },
    'form.level' (val) {
      if (val === 1) {
        this.form.strParentMenu = ''
      }
    }
  },
  components: {
    MenuIconUpload
  }
}
</script>

<style scoped lang="scss" >
.menu-info.container {
  width: 100%;
  box-sizing: border-box;
  padding-left: 12px;
  padding-top: 20px;
  ::v-deep .m-cascader {
    height: 32px;
  }
}
</style>
